// ===================================
// TODO CLEAN - QUOTE MODAL CONTEXT
// Global state for quote modal visibility
// ===================================

import React, { createContext, useContext, useState, useCallback } from 'react';

// ==========================================
// INTERFACES
// ==========================================

interface QuoteModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

// ==========================================
// CONTEXT
// ==========================================

const QuoteModalContext = createContext<QuoteModalContextType | undefined>(undefined);

// ==========================================
// PROVIDER
// ==========================================

export const QuoteModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <QuoteModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </QuoteModalContext.Provider>
  );
};

// ==========================================
// HOOK
// ==========================================

export const useQuoteModal = (): QuoteModalContextType => {
  const context = useContext(QuoteModalContext);
  if (!context) {
    throw new Error('useQuoteModal must be used within a QuoteModalProvider');
  }
  return context;
};
